import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

const PageTemplate = css`
  .site-main {
    background #fff;
    padding-bottom: 4vw;
  }
  .post-content {
    max-width: 1000px;
    margin: 0 auto;
  }
`;

const aboutCreator = css`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 3rem;

  img {
    max-width: 100% !important;
    border-radius: 4px;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const About: React.FunctionComponent = () => (
  <IndexLayout>
    <Helmet>
      <title>About Purple11</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>A Word About Giggster Guide</PostFullTitle>
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
                The goal with this new website is to bring fun &amp; easy tutorials and tips for
                photography and retouching.
              </p>
              <h2>About the creator</h2>
              <div className={`${aboutCreator}`}>
                <p>
                  Hey there! 👋
                  <br />
                  <br />
                  I'm Seb, the guy behind this website. Someday I may add more details
                  about myself here. In the meantime, you can have a look at another fun project of
                  mine called <a href="https://muted.io/">muted.io</a>, where I create interactive references and tools for music theory. I also invite you to check out{' '}
                  <a href="https://fffuel.co/">fffuel</a>, which will be a home for me to share HTML5 templates that I design. <a href="https://multicolor.io/">multicolor.io</a> is a place where I share some of my photography. Finally, you can head over to <a href="https://sebseb.co/">my personal page</a> for some of the other things I'm creating on the web.
                </p>
                <img src="/guide/images/seb.jpg" alt="Seb" />
              </div>
            </div>
          </PostFullContent>
        </article>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
